import i18nextConfig from '@icims-design-system/i18next';

import localeConfig from './config/localeConfig';

export const i18n = i18nextConfig({ ...localeConfig });
